import * as React from 'react'

import { CopyIcon } from 'lucide-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { cn } from '~/client/src/shared/utils/cn'
import { toast } from '~/client/src/shared/utils/toast'

interface IProps {
  traceId: string
  className?: string
}

const TraceIdDisplay: React.FC<IProps> = ({ traceId, className }) => {
  const copy = () => {
    navigator.clipboard.writeText(traceId)
    toast.success(Localization.translator.copiedToClipboard)
  }

  return (
    <div
      className={cn(
        'tw:inline-flex tw:items-center tw:gap-1 tw:text-app-micro tw:text-muted-foreground',
        className,
      )}
    >
      <span>{Localization.translator.traceId}:</span>
      <code className="tw:font-mono tw:text-app-mono-micro tw:text-foreground">
        {traceId}
      </code>
      <Button
        variant="ghost"
        size="icon-xs"
        aria-label={Localization.translator.copyTraceId}
        onClick={copy}
      >
        <CopyIcon />
      </Button>
    </div>
  )
}

export default TraceIdDisplay
